import { render, staticRenderFns } from "./MonacoDiffEditor.vue?vue&type=template&id=0fbf5c6a&scoped=true&"
import script from "./MonacoDiffEditor.vue?vue&type=script&lang=js&"
export * from "./MonacoDiffEditor.vue?vue&type=script&lang=js&"
import style0 from "./MonacoDiffEditor.vue?vue&type=style&index=0&id=0fbf5c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf5c6a",
  null
  
)

export default component.exports